import LoaderMain from 'components/shared/LoaderMain';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const FlightDetailsSkeleton: FC = () => {
  
  return (
  <>
      <div className="default-shadow flight-details-item">
        <div className="title-underline text-lg mb-20">
          <Skeleton width={140} />
        </div>
        <div className="flight-details-order">
          <div className="flight-details-info">
            <div className="flex-row mb-20 text-sm">
              <div className="mr-10">
                <div className="mb-5">
                  <Skeleton width={110} />
                </div>
                <div className="mb-5">
                  <Skeleton width={80} />
                </div>
                <div className="mb-5">
                  <Skeleton width={80} />
                </div>
                <div className="mb-5">
                  <Skeleton width={70} />
                </div>
                <div className="mb-5">
                  <Skeleton width={40} />
                </div>
                <div className="mb-5">
                  <Skeleton width={100} />
                </div>
              </div>
              <div className="text-bold">
                <div className="mb-5">
                  <Skeleton width={150} />
                </div>
                <div className="mb-5">
                  <Skeleton width={150} />
                </div>
                <div className="mb-5">
                  <Skeleton width={140} />
                </div>
                <div className="mb-5">
                  <Skeleton width={100} />
                </div>
                <div className="mb-5">
                  <Skeleton width={200} />
                </div>
                <div className="mb-5">
                  <Skeleton width={140} />
                </div>
              </div>
            </div>

            <div className="color-danger text-bold text-sm text-lh-sm">
              <Skeleton width={'100%'} />
            </div>

            <div className="flight-details-table">
              {[...Array(3)].map((_, index) => (
                <div className="table-row" key={index}>
                  <span className="cell">
                    <Skeleton width={80} />
                  </span>
                  <span className="cell">
                    <Skeleton width={70} />
                  </span>
                  <span className="cell">
                    <Skeleton width={50} />
                  </span>
                </div>
              ))}
              <div className="table-bottom">
                <span className="text-bold">
                  <Skeleton width={80} />
                </span>
                <span className="price text-bold">
                  <Skeleton width={80} />
                </span>
              </div>
            </div>
          </div>
          <div className="flight-details-map">
            <div className="map">
              <Skeleton height={300} />
            </div>
          </div>
        </div>
      </div>

      {[...Array(2)].map((_gds, index) => (
        <div className="default-shadow flight-details-item flight-details-ticket" key={index}>
          <div className="flex-between ticket-header">
            <span>
              <Skeleton width={150} />
            </span>
            <span>
              <Skeleton width={30} />
            </span>
          </div>
          <div className="ticket-details-info">
            <div className="item">
              <span className="city text-bold">
                <Skeleton width={130} />
              </span>
              <span className="time text-bold">
                <Skeleton width={130} />
              </span>
              <span className="day">
                <Skeleton width={40} />
              </span>
            </div>
            <div className="item">
              <span className="city text-bold">
                <Skeleton width={140} />
              </span>
              <span className="time text-bold">
                <Skeleton width={130} />
              </span>
              <span className="day">
                <Skeleton width={40} />
              </span>
            </div>
            <div className="item">
              <Skeleton width={130} />
              <span className="day">
                <Skeleton width={30} />
              </span>
            </div>
            <div className="item">
              <Skeleton width={130} />
              <span className="time text-bold">
                <Skeleton width={100} />
              </span>
              <span className="day">
                <Skeleton width={40} />
              </span>
            </div>
          </div>
          <div>
            <div className="flight-details-segment" key={index}>
              <div className="item short">
                <span className="text-bold">
                  <Skeleton width={100} />
                </span>
                <Skeleton width={80} />
              </div>
              <div className="item short">
                <span className="text-bold">
                  <Skeleton width={100} />
                </span>
                <span>
                  <Skeleton width={80} />
                </span>
              </div>
              <div className="item long">
                <span className="text-bold">
                  <Skeleton width={100} />
                </span>
                <span>
                  <Skeleton width={100} />
                </span>
              </div>
              <div className="item short">
                <span className="text-bold">
                  <Skeleton width={110} />
                </span>
                <span>
                  <Skeleton width={80} />
                </span>
              </div>
              <div className="item long">
                <span className="text-bold">
                  <Skeleton width={90} />
                </span>
                <span>
                  <Skeleton width={90} />
                </span>
              </div>
              <div className="item short">
                <span className="text-bold">
                  <Skeleton width={100} />
                </span>
                <span>
                  <Skeleton width={80} />
                </span>
              </div>
              <div className="item short">
                <span className="text-bold">
                  <Skeleton width={90} />
                </span>
                <span>
                  <Skeleton width={80} />
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
      <div className="flex-between flight-details-total mt-30 mb-20">
        <Skeleton width={300} height={120} />
        <div className="total-price">
          <span className="text-bold text-md mb-10 mt-10">
            <span>
              <Skeleton width={100} />
            </span>
          </span>
          <span className="text-sm mb-20">
            <span>
              <Skeleton width={100} height={18} />
            </span>
          </span>
          <Skeleton width={150} height={36} />
        </div>
      </div>
      <LoaderMain systemProducts="Flights" systemProductsDetails="LoadingDetails" />
  </>
  );
};

export default FlightDetailsSkeleton;
